import * as React from 'react';
import AlignContext from "./AlignContext";
import Box from "../Box"; // An empty text node that uses a zero-width space (\u200B) via a ::before
// pseudo-element to establish baseline of the alignment reference within the
// baseline alignment group.

var TextAligner = function TextAligner() {
  return /*#__PURE__*/React.createElement(AlignContext.Consumer, null, function (_ref) {
    var lineHeight = _ref.lineHeight,
        size = _ref.size;

    if (!size) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Box, {
      className: "TextAligner",
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      style: {
        lineHeight: "".concat(lineHeight, "px"),
        fontSize: "".concat(size, "px")
      }
    });
  });
};

export default TextAligner;